// Turbolinks対応
document.addEventListener('DOMContentLoaded', initPlayerStatsSort);
document.addEventListener('turbolinks:load', initPlayerStatsSort);
document.addEventListener('turbo:load', initPlayerStatsSort);

function initPlayerStatsSort() {
  
  const table = document.getElementById('playerStatsTable');
  const pageOffset = parseInt((table && table.dataset.offset) || '0', 10);
  const sortInfo = document.getElementById('sortInfo');
  const sortText = document.getElementById('sortText');
  const userOnlyFilter = document.getElementById('userOnlyFilter');
  
  if (!table) {
    return;
  }

  // 既存のイベントリスナーを削除
  const existingHeaders = table.querySelectorAll('th.sortable');
  existingHeaders.forEach(header => {
    const newHeader = header.cloneNode(true);
    header.parentNode.replaceChild(newHeader, header);
  });

  let currentSort = {
    column: null,
    direction: 'asc'
  };

  // 初期表示時に行番号を設定
  updateRowNumbers();

  // フィルター機能の設定
  if (userOnlyFilter) {
    userOnlyFilter.addEventListener('change', function() {
      applyFilter();
      updateRowNumbers();
    });
  }

  // ソート可能なヘッダーにクリックイベントを追加
  const sortableHeaders = table.querySelectorAll('th.sortable');
  
  sortableHeaders.forEach(header => {
    header.style.cursor = 'pointer';
    header.addEventListener('click', function() {
      const column = this.dataset.column;
      const type = this.dataset.type;
      
      // ソート方向を決定
      if (currentSort.column === column) {
        currentSort.direction = currentSort.direction === 'desc' ? 'asc' : 'desc';
      } else {
        currentSort.direction = 'desc';
      }
      currentSort.column = column;
      
      // テーブルをソート
      sortTable(column, type, currentSort.direction);
      
      // ヘッダーのアイコンを更新
      updateSortIcons(header, currentSort.direction);
    });
  });

  function applyFilter() {
    const tbody = table.querySelector('tbody');
    const rows = tbody.querySelectorAll('tr');
    const filterUserOnly = userOnlyFilter && userOnlyFilter.checked;
    
    rows.forEach(row => {
      const hasUser = row.dataset.hasUser === 'true';
      
      if (filterUserOnly && !hasUser) {
        row.style.display = 'none';
      } else {
        row.style.display = '';
      }
    });
    
    // フィルター適用後に行の背景色を更新
    updateRowColorsForVisibleRows();
  }

  function sortTable(column, type, direction) {
    const tbody = table.querySelector('tbody');
    const rows = Array.from(tbody.querySelectorAll('tr'));
    
    // 列のインデックスを取得
    const columnIndex = getColumnIndex(column);
    
    rows.sort((a, b) => {
      const aValue = a.cells[columnIndex].dataset.sort;
      const bValue = b.cells[columnIndex].dataset.sort;
      
      let comparison = 0;
      
      if (type === 'number') {
        const aNum = parseFloat(aValue) || 0;
        const bNum = parseFloat(bValue) || 0;
        comparison = aNum - bNum;
      } else if (type === 'date') {
        const aNum = parseFloat(aValue) || 0;
        const bNum = parseFloat(bValue) || 0;
        comparison = aNum - bNum;
      } else {
        comparison = aValue.localeCompare(bValue, 'ja');
      }
      
      return direction === 'desc' ? -comparison : comparison;
    });
    
    // 行を再配置
    rows.forEach(row => tbody.appendChild(row));
    
    // フィルターを再適用
    applyFilter();
    
    // 行番号を更新
    updateRowNumbers();
  }

  function getColumnIndex(column) {
    // ハードコードのマップは列追加時にズレるため、DOMのヘッダー位置から動的に求める
    const th = table.querySelector(`th[data-column="${column}"]`);
    return th ? th.cellIndex : -1;
  }

  function updateSortIcons(activeHeader, direction) {
    // すべてのアイコンをリセット
    sortableHeaders.forEach(header => {
      const icon = header.querySelector('.sort-icon');
      if (icon) {
        icon.className = 'fa fa-sort sort-icon';
      }
      header.classList.remove('sort-active');
    });
    
    // アクティブなヘッダーのアイコンを更新
    const activeIcon = activeHeader.querySelector('.sort-icon');
    if (activeIcon) {
      activeHeader.classList.add('sort-active');
      
      if (direction === 'asc') {
        activeIcon.className = 'fa fa-sort-up sort-icon sort-active';
      } else {
        activeIcon.className = 'fa fa-sort-down sort-icon sort-active';
      }
    }
  }

  function updateRowColors(rows) {
    rows.forEach((row, index) => {
      row.classList.remove('row-even', 'row-odd');
      row.classList.add(index % 2 === 0 ? 'row-even' : 'row-odd');
    });
  }

  function updateRowColorsForVisibleRows() {
    const tbody = table.querySelector('tbody');
    const visibleRows = Array.from(tbody.querySelectorAll('tr')).filter(row => row.style.display !== 'none');
    
    visibleRows.forEach((row, index) => {
      row.classList.remove('row-even', 'row-odd');
      row.classList.add(index % 2 === 0 ? 'row-even' : 'row-odd');
    });
  }

  function updateRowNumbers() {
    const tbody = table.querySelector('tbody');
    const visibleRows = Array.from(tbody.querySelectorAll('tr')).filter(row => row.style.display !== 'none');
    
    visibleRows.forEach((row, index) => {
      const rowNumber = row.querySelector('.row-number');
      if (rowNumber) {
        rowNumber.textContent = pageOffset + index + 1;
      }
    });
  }
} 